import styled from "styled-components"
import padding from "../global/padding"

const Section = styled.div`
  padding-top: ${padding.base};
  padding-bottom: ${padding.base};
`

export const SectionPosRel = styled(Section)`
  position: relative;
`

export default Section
